import gql from "graphql-tag";
import { request } from "../utils/request";
import { print } from "graphql";

export const getInventoryForProduct = ({ handle }) => {
	if (!handle) {
		return {
			isLoading: false,
			data: null,
			error: null,
		};
	}

	// const productsQuery = {}
	const productsQuery = gql`
		query getProductByHandle($handle: String!) {
			productByHandle(handle: $handle) {
				variants(first: 25) {
					edges {
						node {
							id
							sku
							inventoryQuantity
							availableForSale
							inventoryItem {
								tracked
							}
						}
					}
				}
			}
		}
	`;

	const domain = process.env.MYSHOPIFY_URL || "tearribles.myshopify.com";

	return request({
		method: "post",
		url:
			"https://c6io3dqyx1.execute-api.us-east-1.amazonaws.com/dev/products?domain=" +
			domain,
		data: {
			query: print(productsQuery),
			variables: {
				handle,
			},
		},
	});
};
